<div class="app-l-page-wrap">
    <div class="app-l-container">
        <div class="emergency-page-card">
            <div class="emergency-page-card__icon">
                <svg-icon icon="get-help" alt="emergency support"></svg-icon>
            </div>
            <h1 class="app-c-heading--h3" translate>contact.need</h1>
            <emergency-contact [user]="user"></emergency-contact>
        </div>
    </div>
</div>